export default __webpack_public_path__ + "static/ISKILLRES-01-20211012122521-661afd9dc8234f6633212d07184c65db.png";